import styled from "styled-components";

export const Container = styled.div`
  margin-left: 0 auto;
  margin-right: 0 auto;
`;
